/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
//actions
import { setFormEditableState } from '@insticator/insticator-ui';
import { getGeneralInfoOrRepopulate, updateGeneralInformationWithValidation } from 'state/actions/accountState/account_data';
// component
import General from 'pages/dashboard/account/general/general';



/* ========== ~~~~~~~~~~ ACCOUNT GENERAL INFO : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ accountData, sessionStatus }) => ({
    fields: accountData.generalInformation.fields,
    savingData: accountData.generalInformation.savingData,
    editable: accountData.generalInformation.editable,
    hasStoredData: Object.keys(accountData.generalInformation.storedData).length > 0,
    accountUUID: sessionStatus.accountUUID
});

// map actions
const mapDispatchToProps = dispatch => ({
    setFormEditableState: (formName, isEditable) => dispatch(setFormEditableState(formName, isEditable)),
    getGeneralInfoOrRepopulate: (hasStoredData, accountUUID) => dispatch(getGeneralInfoOrRepopulate(hasStoredData, accountUUID)),
    updateGeneralInformationWithValidation: (fields, updatedFormData, accountUUID) => dispatch(updateGeneralInformationWithValidation(fields, updatedFormData, accountUUID))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(General);
